import { render, staticRenderFns } from "./vsList.vue?vue&type=template&id=38998322&lang=html&"
import script from "./vsList.vue?vue&type=script&lang=js&"
export * from "./vsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "vsList.vue"
export default component.exports